import { FC } from 'react';

import { AnimatePresence, motion } from 'framer-motion';

import { VStack } from '@ui-furniture/elements';
import { movement } from '@ui-furniture/lib/utils';
import { x } from '@ui-furniture/style';

import { MessageBubble } from './message-bubble';

import { Message } from '../types/message';
import { MessageSide } from '../types/message-side';

export const MessageGroup: FC<{
  side: MessageSide;
  messages: Array<Message>;
}> = ({ messages, side }) => (
  <VStack spacing='2px'>
    <AnimatePresence>
      {messages.map((message, index) => (
        <x.div
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          as={motion.div}
          alignSelf={side === 'left' ? 'flex-start' : 'flex-end'}
          initial='initial'
          animate='visible'
          variants={{
            initial: {
              y: movement.sm,
              opacity: 0,
            },
            visible: {
              y: 0,
              opacity: 1,
            },
          }}
        >
          <MessageBubble side={side} isGroupFirst={index === 0}>
            {message.text}
          </MessageBubble>
        </x.div>
      ))}
    </AnimatePresence>
  </VStack>
);
